import React from "react";
import { useNavigate } from "react-router";
import { StyckeCompact } from "./ContentStyles";
import Rules from "./Rules";
import { Branding } from "../services/misc";
import "./PricePage.scss";





const PricingModule = () => {

  return (
<>
                {/* CARDS */}
                <section className="pricing-cards" aria-labelledby="pricing-packages-title">
                    <p className="pricing-cards__intro">
                        Här kan du jämföra våra olika abonnemang för obemannad butik och välja den lösning som passar din verksamhet bäst.
                    </p>
                    <div className="pricing-cards__grid">
                        {priceplan.plans.map((p) => (
                            <article
                                key={p.key}
                                className={`pricing-card ${p.featured ? "pricing-card--featured" : ""}`}
                                aria-labelledby={`plan-title-${p.key}`}
                            >
                                {p.featured && (
                                    <div className="pricing-card__badge">Mest populär</div>
                                )}

                                <h3 id={`plan-title-${p.key}`} className="pricing-card__title">{p.title}</h3>

                                <div className="pricing-card__priceRow">
                                    <div className="pricing-card__price">{p.price}:-</div>
                                    <div className="pricing-card__period">{p.period}</div>
                                </div>

                                <div className="pricing-card__details" role="list">
                                    {p.details.map((d, idx) => (
                                        <div
                                            key={idx}
                                            className={`pricing-row ${d.isExample ? "pricing-row--example" : ""}`}
                                            role="listitem"
                                        >
                                            <div className="pricing-row__label">{d.label}</div>
                                            <div className="pricing-row__value">{d.value}</div>
                                        </div>
                                    ))}
                                </div>

{/*                                 <button
                                    className="pricing-card__cta"
                                    style={
                                        p.featured
                                            ? { backgroundColor: "#fff", color: "#ff8800" }
                                            : { backgroundColor: "#ff8800", color: "#fff" }
                                    }
                                    onClick={() => handleSubmitProd(p.key)}
                                    type="button"
                                    aria-label={`Välj paketet ${p.title}`}
                                >
                                    Starta med detta paket <span className="pricing-card__arrow">→</span>
                                </button> */}
                            </article>
                        ))}
                    </div>

                    <div className="pricing-note">
                        <StyckeCompact>
                            * Används eget avtal för Swish Handel utgår denna kostnad.<br></br>
                            ** Butiken kan pausas och då deviteras ingen månadsavgift.<br></br>
                            För att en fysisk butik ska fungera behövs ett elektriskt lås. En lokal låssmed kan hjälpa dig med installationen.<br />
                            Fakturering sker i förväg, tre månader i taget. Uppsägning eller pausning av tjänsten ska ske innan en ny tremånadersperiod påbörjas.
                            <Rules />
                        </StyckeCompact>
                    </div>
                </section>

</>    

  );
};

    export const priceplan = {
        defaultPlanId : 2,
        plans : [
            {
                planId:1,
                Artnr: "NS1",
                title: "Kylskåp 250L",
                price: 1295,
                period: "/månad",
                details: [
                    { label: "Bindningstid", value: "36 månader" },
                    { label: "Startkostnad", value: "0:-" },
                    { label: "Max antal varor", value: "25" },
                    { label: "Uppkoppling", value: "WiFi" },
                    { label: "Transaktionskostnad", value: "0.20:-/köp" },
                    { label: "Swishkostnad*", value: "1.50:-/köp" },
                    { label: "Applikationsexempel", value: "Tex: Lunch, dryck, snacks mm", isExample: true },              
                    { label: "Support", value: "3 arbetsdagar"}
                ],
                featured: false,
            },
            {
                planId:2,                
                Artnr: "NS2",
                title: "Butik micro",
                price: 495,
                period: "/månad",
                details: [
                    { label: "Bindningstid", value: "24 månader" },
                    { label: "Startkostnad", value: "0:-" },
                    { label: "Max antal varor", value: "5" },
                    { label: "Uppkoppling", value: "WiFi" },
                    { label: "Transaktionskostnad", value: "0.20:-/köp" },
                    { label: "Swishkostnad*", value: "1.50:-/köp" },
                    { label: "Applikationsexempel", value: "Tex: Honung, äggförsäljning", isExample: true },
                    { label: "Support", value: "3 arbetsdagar"}
                ],
                featured: false,
            },
            {
                planId:3,                
                Artnr: "NS3",
                title: "Butik standard",
                price: 1495,
                period: "/månad",
                details: [
                    { label: "Bindningstid", value: "24 månader" },
                    { label: "Startkostnad", value: "0:-" },
                    { label: "Max antal varor", value: "50" },
                    { label: "Uppkoppling", value: "WiFi" },
                    { label: "Transaktionskostnad", value: "0.20:-/köp" },
                    { label: "Swishkostnad*", value: "1.50:-/köp" },
                    { label: "Applikationsexempel", value: "Tex: Gårdsbutik, 9-Hålet", isExample: true },
                    { label: "Support", value: "1 arbetsdag"}
                ],
                featured: true,
            },
            {
                planId:4,                
                Artnr: "NS4",
                title: "Butik large",
                price: 2495,
                period: "/månad",
                details: [
                    { label: "Bindningstid", value: "24 månader" },
                    { label: "Startkostnad", value: "0:-" },
                    { label: "Max antal varor", value: "200" },
                    { label: "Uppkoppling", value: "WiFi" },
                    { label: "Transaktionskostnad", value: "0.20:-/köp" },
                    { label: "Swishkostnad*", value: "1.50:-/köp" },                    
                    { label: "Applikationsexempel", value: "Tex: Gårdsbutik, Kiosk, Närbutik", isExample: true },
                    { label: "Support", value: "1 arbetsdagar"}
                ],
                featured: false,
            },
            {
                planId:5,                
                Artnr: "NS5",
                title: "Butik flex",
                price: 1495,
                period: "/månad",
                details: [
                    { label: "Bindningstid", value: "0 månader" },
                    { label: "Startkostnad", value: "7500:-" },
                    { label: "Max antal varor", value: "50" },
                    { label: "Uppkoppling", value: "WiFi" },
                    { label: "Transaktionskostnad", value: "0.20:-/köp" },
                    { label: "Swishkostnad*", value: "1.50:-/köp" },                    
                    { label: "Applikationsexempel", value: "Säsong", isExample: true },
                    { label: "Support", value: "3 arbetsdagar"},
                    { label: "Pausingsbar**", value: "Ja"}                    
                ],
                featured: false,
            },            
        ]
    };

export default PricingModule;